import { render, staticRenderFns } from "./choiceVideoImage.vue?vue&type=template&id=2bdd979a&"
import script from "./choiceVideoImage.vue?vue&type=script&lang=js&"
export * from "./choiceVideoImage.vue?vue&type=script&lang=js&"
import style0 from "./choiceVideoImage.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports